import { UPDATE_BASE_VENUE } from 'widget/experiences/actions/ActionTypes'

export const updateBaseVenue = venue => ({
  type: UPDATE_BASE_VENUE,
  venue,
})
